import React, { HTMLAttributes } from 'react'

import { cn } from '@/lib/utils'

type Props = Omit<HTMLAttributes<HTMLDivElement>, 'children'> & {
  input: string
  limit: number
}

const CharacterLimitIndicator: React.FC<Props> = ({
  input,
  limit,
  className,
  ...props
}) => {
  const inputLength = input.length
  const isOverLimit = inputLength > limit

  return (
    <div
      className={cn(
        'text-xs',
        isOverLimit ? 'text-destructive' : 'text-dim',
        className,
      )}
      {...props}
    >
      {inputLength}/{limit}
    </div>
  )
}

export default CharacterLimitIndicator
